module.exports = __webpack_public_path__ + "static/media/NX_logo_horizontal.92a6b999.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/NX_logo_horizontal.svg
// module id = 159
// module chunks = 0